import { render, staticRenderFns } from "./ProductSearchModal.vue?vue&type=template&id=2885078e&scoped=true&"
import script from "./ProductSearchModal.vue?vue&type=script&lang=js&"
export * from "./ProductSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductSearchModal.vue?vue&type=style&index=0&id=2885078e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2885078e",
  null
  
)

export default component.exports